module.exports = __webpack_public_path__ + "static/media/logo_DeepL_Pro.1e40cc84.svg";